import styled from "styled-components";
import { colors, typeface } from "@sonder/ui/source/styled/theme";

export const Wrapper = styled.div`
  background: ${colors.white};
  box-sizing: border-box;
  color: ${colors.gray4};
  display: flex;
  flex-direction: column;
  font-family: ${typeface.primary};
  font-size: 1rem;
  line-height: 1.3rem;
  text-align: left;
`;
